export var isFullWidthAppearance = function isFullWidthAppearance(appearance) {
  return appearance === 'full-width';
};
export var isFullPageAppearance = function isFullPageAppearance(appearance) {
  return appearance === 'full-page';
};
export var isCommentAppearance = function isCommentAppearance(appearance) {
  return appearance === 'comment';
};
export var isFullWidthOrFullPageAppearance = function isFullWidthOrFullPageAppearance(appearance) {
  return isFullPageAppearance(appearance) || isFullWidthAppearance(appearance);
};